import React from 'react';

const Buttons = ({ type, onSubmitContinue, onSubmitView, onSubmitEdit }) => {
  return (
    <div className="row mt-25">
      <div className='col-md-10 col-md-offset-1'>
        <div className='row'>
          {type === 'report-edit' &&
            <>
              <div className="col-sm-5 pr-sm-0">
                <button type="button" data-dismiss="modal" className="btn btn-block btn-light-purple">
                  Cancel
                </button>
              </div>

              <div className="col-sm-7 mt-15 mt-sm-0">
                <button onClick={onSubmitEdit} type="button" className="btn btn-block btn-purple">
                  Submit edit
                </button>
              </div>
            </>
          }

          {type !== 'report-edit' &&
            <>
              <div className="col-md-6 pr-md-0">
                <button onClick={onSubmitView} type="button" className="btn btn-block btn-purple">
                  Submit and View Report
                </button>
              </div>

              <div className="col-md-6 mt-15 mt-md-0">
                <button onClick={onSubmitContinue} type="button" className="btn btn-block btn-purple">
                  Submit and Continue Search
                </button>
              </div>
            </>
          }
        </div>
      </div>
    </div>
  );
};

export default Buttons;
